<template>
	<div class="about">
		<div class="swiper">
			<img src="../assets/image/gs.jpg" alt="" class="banner">
		</div>
		<div class="a-content">
			<div class="contanier">

				<p>深圳市粤之彩印刷有限公司创立于2003年8月份，注册资本5000万元人民币，拥有6000平方米厂房，是一家高科技数字印刷设备为依托的现代化印刷企业。</p>
				<br>
				<p>我们拥有德国海德堡CTP印前制版及印前波拉裁切系统、印刷标准化色彩管理系统、印后折页无缝数据标准化管理系统；德国海德堡对开四色、海德堡四开四色、海德堡对开双色机、海德堡对开单色机等15个印刷单元；印后德国海德堡波拉切纸机、海德堡折页机、海德堡全梳万能折页机、马天尼骑订龙、马天尼胶装龙、马天尼锁线机等全套高性能设备。
				</p>
				<br>
				<p>我们可以实现从排版、设计、制版、印刷、折页、装订一条龙生产服务。我们的业务印刷范围覆盖：摄影画册、书刊、企业宣传、产品、宣传海报、产品说明书、手提袋纸袋、展会物料等众多以教育领域产品印刷为主。尤其是在宣传册印刷方面，我们有自己近二十年积累了独特的见解！
				</p>
				<br>
				<p>为了响应国家产业升级，打造环保印刷的号召，我们坚持使用“绿色纸张”，“绿色油墨”，坚持“绿色印刷”。我们不仅通过了ISO9001质量管理体系认证、ISO14001环境管理体系认证、OHSAS18001职业健康安全管理体系认证、FSC®（FSC®-C158775）森林认证、绿色印刷十环认证。还成为广东省印刷领域核心标杆印刷企业。同时我们获得了广东省政府印刷定点单位、深圳市政府印刷定点单位、深圳市印协常务理事单位、连续七年获得广东省守合同重信用企业、新闻出版广电局出版物承印单位等荣誉。
				</p>
				<br>
				<p>自公司成立以来，我们秉承“质量为本、诚信为旨、客户为尊”的经营理念。追求一流的品质，一流的服务，确保产品优质高档。我们建立有完善的质量+增值服务体系。并以ISO9001质量管理体系为标准，严格执行，不断的提高管理服务，
					并赢得了客户的广泛赞誉。我们的客户遍及全国各地以及港澳台、东南亚欧美等十几个国家和地区。过去我们积累了丰富的实战经验，未来我们将更好的服务于全球客户。</p>
				<br>
				<p><b>粤之彩印刷，我们用心做好印刷，感谢您给我们印得更好的机会！</b></p>
			</div>
		</div>

		<div class="bg-grey">
			<div class="contanier">
				<div class="section-title">
					<h2>资质齐全</h2>
					<p>荣誉不只是对我们的肯定，更是继续前进的动力</p>
				</div>
				<certs></certs>
			</div>
		</div>
		<!-- 团队风采 -->
		<div class="tim">
			<!-- 	<div class="contanier"> -->
			<div class="section-title">
				<h2>团队风采</h2>
				<p>倾我所有 尽我所能 竭诚用户 诚信天下</p>
			</div>
			<div class="t-content">
				<div class="tc-t">
					<img src="../assets/image/t-3.jpg" alt="" class="banner">
					<img src="../assets/image/t-4.jpg" alt="" class="banner">
					<img src="../assets/image/t-6.jpg" alt="" class="banner">
					<img src="../assets/image/t-9.jpg" alt="" class="banner">
				</div>
				<div class="tc-b">
					<img src="../assets/image/t-5.jpg" class="tc-bo banner">
					<div class="tc-5">
						<div class="ti-r">
							<img src="../assets/image/t-1.jpg" alt="" class="banner">
							<img src="../assets/image/t-7.jpg" alt="" class="banner">
						</div>
						<div class="ti-r">
							<img src="../assets/image/t-8.jpg" alt="" class="banner">
							<img src="../assets/image/t-2.jpg" alt="" class="banner">
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- </div> -->
		<!-- 先进设备 -->
		<!-- 先进设备 -->
		<div class="shebei">
			<div class="contanier">
				<div class="section-title">
					<h2>先进设备</h2>
					<p>拥有当今国内一线印前、印中及后道设备，满足不同客户的个性化需求</p>
				</div>
				<ul class="sb-list">
					<li>
						<img src="../assets/image/sb9.jpg" alt="">
						<!--						<p>海德堡印刷机</p>-->
					</li>
					<li>
						<img src="../assets/image/sb10.jpg" alt="">
						<!--						<p>全自动锁线机</p>-->
					</li>
					<li>
						<img src="../assets/image/sb11.jpg" alt="">
						<!--						<p>配页机</p>-->
					</li>
					<li>
						<img src="../assets/image/sb12.jpg" alt="">
						<!--						<p>折页机</p>-->
					</li>
				</ul>
				<ul class="sb-list">
					<li>
						<img src="../assets/image/sb1.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/sb2.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/sb3.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/sb4.jpg" alt="">
					</li>
				</ul>
				<ul class="sb-list">
					<li>
						<img src="../assets/image/sb5.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/sb6.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/sb7.jpg" alt="">
					</li>
					<li>
						<img src="../assets/image/sb8.jpg" alt="">
					</li>
				</ul>
			</div>
		</div>


	</div>
</template>

<script>
	import Certs from '../components/Certs.vue'
	export default {
		components: {
			Certs
		}
	}
</script>

<style lang="less">
	@import '../assets/css/main.less';
	@import '../assets/css/about.less';
</style>
